import { QUERY_KEYS } from 'api/query-keys';
import { availabilityService } from 'api/services';
import { WorkersAvailabilityPaginated } from 'api/services/availability/availability-service.schema';
import { DateTime } from 'luxon';
import { useInfiniteQuery } from 'react-query';
import { useSiteDetection } from 'shared/hooks';
import { CACHE_TIME_LONG } from 'shared/react-query/query-defaults';

export const useGetAvailableWorkers = (params: {
  search: string | undefined;
  fromDate: DateTime;
  pageSizeParam: number;
}) => {
  const { site } = useSiteDetection();

  return useInfiniteQuery<WorkersAvailabilityPaginated, Error>({
    queryKey: QUERY_KEYS.workersAvailability(params.search, params.fromDate.toISODate()),
    queryFn: async ({ pageParam = 0 }) => {
      return await availabilityService.getWorkersAvailability({
        ...params,
        fromDate: params.fromDate.toISODate(),
        site,
        pageParam,
      });
    },
    cacheTime: CACHE_TIME_LONG,
    staleTime: CACHE_TIME_LONG,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.hasNextPage) {
        return allPages.length;
      }
      return undefined;
    },
  });
};
